import { DateTime } from 'luxon';

// https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
const FORMAT_DATE = 'LL月dd日';

export const format = (d: Date): string => DateTime.fromJSDate(d).toLocal().toFormat(FORMAT_DATE);

export const formatShort = (d: Date): string => DateTime.fromJSDate(d).toLocal().toFormat('LL/dd');
